import { render } from "./ViewConvenio.vue?vue&type=template&id=7661b359&scoped=true"
import script from "./ViewConvenio.vue?vue&type=script&lang=js"
export * from "./ViewConvenio.vue?vue&type=script&lang=js"

import "./ViewConvenio.vue?vue&type=style&index=0&id=7661b359&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7661b359"

export default script